import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss'],
})
export class TermsDialogComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
